/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Currentbalance2Inputs */

const zh_adminsubs_currentbalance2 = /** @type {(inputs: Adminsubs_Currentbalance2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前余额`)
};

const en_adminsubs_currentbalance2 = /** @type {(inputs: Adminsubs_Currentbalance2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Balance`)
};

const es_adminsubs_currentbalance2 = /** @type {(inputs: Adminsubs_Currentbalance2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saldo actual`)
};

/**
* | output |
* | --- |
* | "Current Balance" |
*
* @param {Adminsubs_Currentbalance2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_currentbalance2 = /** @type {((inputs?: Adminsubs_Currentbalance2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Currentbalance2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_currentbalance2(inputs)
	if (locale === "en") return en_adminsubs_currentbalance2(inputs)
	return es_adminsubs_currentbalance2(inputs)
});
export { adminsubs_currentbalance2 as "adminSubs_currentBalance" }